//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { ANALYTIC_SOURCE_MODULES } from '~/services/analyticEvents';

export default {
    name: 'RequireSignupLink',
    props: {
        href: {
            type: String,
            required: true
        },
        target: {
            type: String,
            default: '_blank'
        },
        rel: {
            type: String,
            default: 'noopener'
        },
        requireSignup: {
            type: Boolean,
            default: true
        },
        source: {
            type: String,
            default: ANALYTIC_SOURCE_MODULES.DOWNLOADABLE_RESOURCE
        }
    },
    computed: {
        ...mapGetters({
            isAuthenticated: 'auth/isAuthenticated'
        })
    },

    methods: {
        handleClick() {
            this.$emit('onClick');
            if (!this.isAuthenticated && this.requireSignup) {
                this.$store.commit('auth/clearAcquisitionAuthTimer', true, { hideModal: true });
                this.$store.commit('auth/setIsSignupHookModal', true);
                this.$store.commit('auth/setSignupHookPayload', {
                    href: this.href,
                    target: this.target,
                    source: this.source
                });
                return;
            }
            window.open(this.href, this.target);
        }
    }
};
